import Icon from './Icon';

/**
 * @param {{ value: string, options: Array<{ value: string, label: string }>, onChange: (v: string)=>void, disabled?: boolean, invalid?: boolean, className?: string, style?: any, [key: string]: any }} props
 */
export default function Select({
  value,
  options,
  onChange,
  disabled = false,
  invalid = false,
  className: callerClassName,
  style: callerStyle,
  ...rest
}) {
  return (
    <div style={{ position: 'relative' }}>
      <select
        value={value}
        disabled={disabled}
        className={`ab-select${callerClassName ? ' ' + callerClassName : ''}`}
        onChange={(e) => onChange?.(e.target.value)}
        {...rest}
        style={{
          width: '100%',
          padding: '6px 30px 6px 10px',
          fontSize: 'var(--ab-text-sm)',
          fontFamily: 'var(--ab-font-sans)',
          color: 'var(--ab-fg)',
          background: disabled ? 'var(--ab-bg-input)' : 'var(--ab-bg)',
          border: invalid ? '1.5px solid var(--ab-denied)' : '1px solid var(--ab-fg)',
          borderRadius: 'var(--ab-radius-sm)',
          appearance: 'none',
          height: 34,
          cursor: disabled ? 'not-allowed' : 'pointer',
          ...callerStyle,
        }}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      <span
        style={{
          position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)',
          pointerEvents: 'none', color: 'var(--ab-fg-subtle)',
        }}
      >
        <Icon name="chevron-down" size={14} />
      </span>
    </div>
  );
}
